module.exports = __webpack_public_path__ + "img/template-2.0fa64a31.jpg";